import { cn } from "../lib/utils";

/* Marca da Vorto — símbolo "V" + logotipo, inline pra pintar junto
   com a página (sem flash de imagem carregando). O traço herda a cor
   do texto (currentColor); o ponto usa o azul oficial da Vorto. */

export function LogoMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 48 48" className={cn("size-7", className)} aria-hidden>
      <path
        d="M11 18 L24 36 L37 18"
        fill="none"
        stroke="currentColor"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="24" cy="9" r="4" fill="#1D4ED8" />
    </svg>
  );
}

export function LogoFull({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 176.657 48"
      className={cn("h-7 w-auto text-foreground", className)}
      role="img"
      aria-label="Vorto"
    >
      <path
        d="M11 18 L24 36 L37 18"
        fill="none"
        stroke="currentColor"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="24" cy="9" r="4" fill="#1D4ED8" />
      <g fill="currentColor" transform="translate(65.229 39) scale(0.04286)">
        <path d="M422 0L196 0L18-700L154-700L302-85L316-85L464-700L600-700L422 0ZM894 14L894 14Q820 14 761-16Q702-46 668-103Q634-160 634-240L634-240L634-256Q634-336 668-393Q702-450 761-480Q820-510 894-510L894-510Q968-510 1027-480Q1086-450 1120-393Q1154-336 1154-256L1154-256L1154-240Q1154-160 1120-103Q1086-46 1027-16Q968 14 894 14ZM894-98L894-98Q952-98 990-135.500Q1028-173 1028-243L1028-243L1028-253Q1028-323 990.500-360.500Q953-398 894-398L894-398Q836-398 798-360.500Q760-323 760-253L760-253L760-243Q760-173 798-135.500Q836-98 894-98ZM1396 0L1270 0L1270-496L1394-496L1394-440L1412-440Q1423-470 1448.500-484Q1474-498 1508-498L1508-498L1568-498L1568-386L1506-386Q1458-386 1427-360.500Q1396-335 1396-282L1396-282L1396 0ZM1996 0L1856 0Q1807 0 1776.500-30.500Q1746-61 1746-112L1746-112L1746-392L1622-392L1622-496L1746-496L1746-650L1872-650L1872-496L2008-496L2008-392L1872-392L1872-134Q1872-104 1900-104L1900-104L1996-104L1996 0ZM2340 14L2340 14Q2266 14 2207-16Q2148-46 2114-103Q2080-160 2080-240L2080-240L2080-256Q2080-336 2114-393Q2148-450 2207-480Q2266-510 2340-510L2340-510Q2414-510 2473-480Q2532-450 2566-393Q2600-336 2600-256L2600-256L2600-240Q2600-160 2566-103Q2532-46 2473-16Q2414 14 2340 14ZM2340-98L2340-98Q2398-98 2436-135.500Q2474-173 2474-243L2474-243L2474-253Q2474-323 2436.500-360.500Q2399-398 2340-398L2340-398Q2282-398 2244-360.500Q2206-323 2206-253L2206-253L2206-243Q2206-173 2244-135.500Q2282-98 2340-98Z" />
      </g>
    </svg>
  );
}
